export enum Routes {
  Index = '/',
  HealthSummary = '/partner/:partnerId/health',
  Monitors = '/partner/:partnerId/monitor',
  MonitorsTab = '/partner/:partnerId/monitor/:tab',
  MonitorAdd = '/partner/:partnerId/monitor/add',
  OutreachEdit = '/partner/:partnerId/monitor/:monitorId/outreach/edit',
  OutreachEditAnchored = '/partner/:partnerId/monitor/:monitorId/outreach/edit#:anchor',
  MonitorDetails = '/partner/:partnerId/monitor/user/:monitorId/detail/:eventId?',
  AutonomousMonitorDetails = '/partner/:partnerId/monitor/autonomous/:monitorId/detail/:eventId?',
  AccessNetworkMonitorDetails = '/partner/:partnerId/monitor/access-network/:monitorId/detail/:eventId?',
  MonitorEdit = '/partner/:partnerId/monitor/:monitorId/edit',
  OutreachRules = '/partner/:partnerId/outreach',
  Configuration = '/partner/:partnerId/configuration',
  Login = '/login',
  LoginCallback = '/implicit/callback',
}

export const LOGIN_SCREEN_ROUTE = Routes.Login;
const getDefaultOrigin = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.origin;
};
export const APP_URL = import.meta.env.VITE_URL || getDefaultOrigin();
export const OKTA_BASE_URL =
  import.meta.env.VITE_OKTA_BASE || 'https://external-dev.sso.plume.com';
export const OKTA_ISSUER =
  import.meta.env.VITE_OKTA_ISSUER || `${OKTA_BASE_URL}/oauth2/default`;
// OKTA_CLIENT_ID needs to be generated per app and updated here
export const OKTA_CLIENT_ID =
  import.meta.env.VITE_OKTA_CLIENT_ID || '0oa12oet8abmbyIde0h8';
export const OKTA_REDIRECT_URI =
  import.meta.env.VITE_OKTA_REDIRECT_URI || `${APP_URL}/implicit/callback`;
export const OKTA_LOGOUT_URI =
  import.meta.env.VITE_OKTA_LOGOUT_URI || getDefaultOrigin();

export const TRANSLATION_FILE_PATH_TEMPLATE =
  import.meta.env.VITE_TRANSLATION_FILE_PATH_TEMPLATE ||
  '/{{lng}}.json' +
    (import.meta.env.VITE_VERSION
      ? '?version=' + import.meta.env.VITE_VERSION
      : '');

export const MIXPANEL_ID =
  import.meta.env.VITE_MIXPANEL_ID || 'd12e7f6edba6904f9ece76f0b143c181';

export const SIGNAL_ENDPOINT_SPHERE =
  import.meta.env.VITE_SIGNAL_ENDPOINT_SPHERE || 'ci';

export const VERSION_ENDPOINT =
  import.meta.env.VITE_VERSION_ENDPOINT ||
  'https://signal-ext.us-west-2.datavinci.dev.plume.tech/reports/version';

export const GRAPHQL_ENDPOINT =
  import.meta.env.VITE_GRAPHQL_ENDPOINT ||
  'https://signal-ext.us-west-2.datavinci.dev.plume.tech/reports/signal';

export const SIGNALGRAPHQL_ENDPOINT =
  import.meta.env.VITE_SIGNALGRAPHQL_ENDPOINT ||
  'https://signal-ci-dev-usw2.hasura.app/v1/graphql';

export const STANDARD_DATE_FORMAT = 'lll';
export const STANDARD_TIME_FORMAT = 'LT';
export const SHORT_DATE_FORMAT = 'MMM DD';
export const SHORT_DATE_TIME_FORMAT = 'LT MMM DD';
export const STANDARD_DATE_TIME_FORMAT = 'L LT';
export const LONG_DATE_TIME_FORMAT = 'MMM DD HH:mm';
export const API_STANDARD_DATE_TIME_TOP_OF_MINUTE =
  'YYYY-MM-DDTHH:mm[:00.000Z]';

export const OUTREACH_CONFIG_MAX_LINES_FOR_TEXTAREA = 10;

export const trendRowDays = 90;
